import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
const NotFound = { template: '<div class="alert alert-danger text-center py-3"><h1>404 resource not found</h1></div>'}

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/action',
			name: 'action',
			component: () => import(/* webpackChunkName: "about" */ './views/Action.vue')
		},
		{
			path: '/delivery-notes',
			name: 'delivery-notes',
			component: () => import('./views/DeliveryNotes.vue')
		},
		{
			path: '/dispatch',
			name: 'dispatch',
			component: () => import('./views/Dispatch.vue')
		},
		{
			path: '/invoices',
			name: 'invoices',
			component: () => import('./views/Invoices.vue')
		},
		{
			path: '/ordering',
			name: 'ordering',
			component: () => import('./views/Ordering.vue')
		},
		{
			path: '/progress',
			name: 'progress',
			component: () => import('./views/Progress.vue')
		},
		{
			path: '/search',
			name: 'search',
			component: () => import('./views/Search.vue')
		},
		{
			path: '/contacts',
			name: 'contacts',
			component: () => import('./views/Contacts.vue')
		},
		{
			path: '/cx-reports',
			name: 'cx-reports',
			component: () => import('./views/CxReports.vue')
		},
		{
			path: '/special-discounts',
			name: 'special-discounts',
			component: () => import('./views/SpecialDiscounts.vue')
		},
		{
			path: '/dx',
			name: 'dx',
			component: () => import('./views/DX.vue')
		},
		{
			path: '/postage',
			name: 'postage',
			component: () => import('./views/Postage.vue')
		},
		{
			path: '/faxes',
			name: 'faxes',
			component: () => import('./views/Faxes.vue')
		},
		{
			path: '/lens-search',
			name: 'lens-search',
			component: () => import('./views/LensSearch.vue')
		},
		{
			path: '/pickups',
			name: 'pickups',
			component: () => import('./views/Pickups.vue')
		},
		{
			path: '/quotes',
			name: 'quotes',
			component: () => import('./views/Quotes.vue')
		},
		{
			path: '/ordering/:jobID',
			name: 'ordering-by-id',
			component: () => import('./views/Ordering.vue'),
			props: true
		},
		{
			path: '/print',
			name: 'print-job',
			component: () => import('./views/PrintOrder.vue'),
			props: true
		},
		{
			path: '/print/:jobID',
			name: 'print-job-id',
			component: () => import('./views/PrintOrder.vue'),
			props: true
		},
		{
			path: '/bulk-print',
			name: 'bulk-print',
			component: () => import('./views/BulkPrint.vue')
		},
		{
			path: '/returns',
			name: 'returns',
			component: () => import('./views/Returns.vue')
		},
		{
			path: '/lab-reports',
			name: 'lab-reports',
			component: () => import('./views/LabReports.vue')
		},
		{
			path: '/delivery-services',
			name: 'delivery-services',
			component: () => import('./views/DeliveryServices.vue')
		},
		{
			path: '/product-update',
			name: 'product-update',
			component: () => import('./views/ProductUpdate.vue')
		},
		{
			path: '/new-product',
			name: 'new-product',
			component: () => import('./views/NewProduct.vue')
		},
		{
			path: '/backup-restore',
			name: 'backup-restore',
			component: () => import('./views/BackupRestore.vue'),
		},
		{
			path: '/flightboard',
			name: 'flightboard',
			component: () => import('./views/Flightboard.vue'),
			meta: {
				hideNavbar: true,
			}
		},
		{
			path: '/update-tracking',
			name: 'update-tracking',
			component: () => import('./views/UpdateTracking.vue'),
			meta: {
				hideNavbar: true,
			}
		},
		{
			path: '/404',
			component: NotFound
		},
		{
			path: '*',
			redirect: '/404'
		}
	],
	linkExactActiveClass: 'active font-weight-bold'
})
